const ITEMS = [
    "Genuine Leather Laptop Bags",
    "Handmade Scented Candles",
    "Souvenir Fridge Magnets",
    "Made-to-Order Manufacturing",
    "OEM / ODM Ready",
    "Americas · Europe · Australia",
];

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative border-y border-[#2E2620] bg-[#14110F] py-5 overflow-hidden"
        aria-hidden="true"
    >
        <div className="marquee-track">
            {[0, 1].map((dup) => (
                <div key={dup} className="flex items-center shrink-0">
                    {ITEMS.map((item) => (
                        <span key={`${dup}-${item}`} className="flex items-center">
                            <span className="font-display italic text-xl sm:text-2xl text-[#6E6156] px-8 whitespace-nowrap">
                                {item}
                            </span>
                            <svg width="10" height="10" viewBox="0 0 10 10" className="shrink-0">
                                <path d="M5 0 L10 5 L5 10 L0 5 Z" fill="#C58B49" opacity="0.7" />
                            </svg>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
